/* Zet aj-boven (bovenaan de pagina, glas) of aj-vast (gescrold, massieve balk).
   aj-overlay komt er alleen op als de eerste sectie een AJ-hero is,
   want alleen dan is er een beeld om overheen te liggen. */
(function () {
  var body = document.body;

  function heeftHero() {
    var eerste = document.querySelector('#MainContent .shopify-section, main .shopify-section');
    return !!(eerste && eerste.querySelector('.aj-hero'));
  }

  if (!heeftHero()) return;
  body.classList.add('aj-overlay');

  var drempel = 40;
  var bezig = false;

  function meten() {
    var y = window.scrollY || window.pageYOffset || 0;
    body.classList.toggle('aj-vast', y > drempel);
    body.classList.toggle('aj-boven', y <= drempel);
    bezig = false;
  }

  function opScroll() {
    if (bezig) return;
    bezig = true;
    window.requestAnimationFrame(meten);
  }

  meten();
  window.addEventListener('scroll', opScroll, { passive: true });
  window.addEventListener('resize', opScroll, { passive: true });
})();
